export default "__VITE_ASSET__DhrbsPBO__"